import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductList from '../../components/DynamicListGrid/DynamicListGrid';
import {getStoredData} from "../../JsonFiles/fetchData";
import { useNavigate } from 'react-router-dom';

const AdminServices = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminServices : {};

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://shahbad-enterprises-backend.vercel.app/services');
        setProducts(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching actvities:', error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <p>Loading services...</p>;
  }

  return (
    <div className="admin-products">
      <h2>Services List</h2>
      <button onClick={() => navigate('/admin/add-services')}>
        Create New Services
      </button>
      <ProductList products={products} fields={fields} redirect={totalData[12].AdminServicesEdit} deleteApi="https://shahbad-enterprises-backend.vercel.app/services"/>
    </div>
  );
};

export default AdminServices;

